import { css, cva } from '@/styled-system/css';

// Design Specs: https://www.figma.com/file/2UlxeTUdKRMOHjl0h3rOg1/Starter-File-Multi-Step-Forms-AKA-Wizards?node-id=119%3A24517

export const wizardFormStyles = css.raw({
  flexGrow: 2,
});

export const wizardHeadingStyles = css.raw({
  display: 'block',
  marginBottom: '400',
});

export const wizardParagraphStyles = css.raw({
  display: 'block',
  marginBottom: '600',
});

export const wizardFormSectionContainerStyles = cva({
  base: {
    marginBottom: '800',

    '&:last-child': {
      marginBottom: '600',
    },
  },
  variants: {
    isInMultiplexListingFlow: {
      true: {
        width: '100%',
        maxWidth: '100%',
      },
      false: {
        maxWidth: { xxl: '656px' },
      },
    },
  },
  defaultVariants: {
    isInMultiplexListingFlow: false,
  },
});

const CONTENT_MAX_WIDTH_WITH_TIP = '728px';
const TIP_CARD_WIDTH = '328px';

export const wizardFlexContainerStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: {
    base: 'minmax(0, 1fr)',
    xl: `minmax(0, ${CONTENT_MAX_WIDTH_WITH_TIP}) ${TIP_CARD_WIDTH}`,
  },
  columnGap: 'layout.vast.looser',
  rowGap: { base: 'layout.loose', md: 'layout.looser' },
  alignItems: 'start',
});

export const wizardLabeledControlStyles = css.raw({
  minWidth: '50%',
});

// Hacky fix for the tip card on wizard pages being aligned slightly left of the ones on other form pages.
export const wizardTipCardLeftSpacingStyles = css.raw({
  marginLeft: { xxl: '19.5px' },
});

export const wizardGridContainerStyles = css.raw({
  display: 'grid',
  gridTemplateColumns: {
    base: 'repeat(6, 1fr)',
    lg: 'repeat(12, 1fr)',
  },
  gap: '400',
});

export const wizardFormColumnStyles = css.raw({
  gridColumnEnd: { base: 'span 6', lg: 'span 12', xxl: 'span 7' },
});

export const wizardTipCardColumnStyles = css.raw({
  gridColumnEnd: { base: 'span 6', lg: 'span 12', xxl: 'span 5' },
});
